export default "__VITE_ASSET__b5369c57__"